import React from 'react';
import { motion } from 'framer-motion';
import { FaCog, FaSync } from 'react-icons/fa';

const ControlButtons = ({ onRefresh, onSettings }) => {
  return (
    <motion.div 
      className="flex space-x-3 mb-6"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}
    >
      <motion.button
        onClick={onSettings}
        className="glass-button px-4 py-3 flex items-center space-x-2 text-gray-700 hover:text-gray-900"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <FaCog className="text-lg" />
        <span className="font-medium">Settings</span>
      </motion.button>
      
      <motion.button
        onClick={onRefresh}
        className="glass-button px-4 py-3 flex items-center space-x-2 text-gray-700 hover:text-gray-900"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <FaSync className="text-lg" />
        <span className="font-medium">Refresh</span>
      </motion.button>
    </motion.div>
  );
};

export default ControlButtons;
